import React from 'react';

import { Checkbox } from 'carbon-components-react';

import { legend } from '../../@types/AppConfiguration';

import './Legend.scss';

export interface MapLegendProps {
  legends: legend[];
  selectedLegendTypes: string[];
  onUpdate: any;
}

const MapLegend: React.FC<MapLegendProps> = ({
  legends = [],
  selectedLegendTypes = [],
  onUpdate,
}) => {
  return (
    <div className="world-map-leadspace-widget__map--legend bx--row">
      {legends.map((legend, index) => {
        const isChecked = selectedLegendTypes.includes(legend.type);
        return (
          <div
            className={`world-map-leadspace-widget__map--legend-checkbox bx--col-lg-8 bx--col-sm-2 ${
              legend.color
            }
            ${isChecked ? 'checked' : 'empty'}`.trim()}
            key={`checkbox-${index}`}
          >
            <Checkbox
              id={`legend-checkbox-${index}`}
              key={`legend-${index}`}
              labelText={legend.title}
              onChange={() => {
                onUpdate(legend.type);
              }}
              value={legend.type}
              defaultChecked={!isChecked}
            />
          </div>
        );
      })}
    </div>
  );
};

export default MapLegend;
